import { useEffect, useState } from 'react';
import { deadlineInfo, type DeadlineInfo, type Deadlineish } from '../lib/format';

type DeadlineJob = Deadlineish;

export interface DeadlineTagProps {
  job: DeadlineJob;
  showSub?: boolean;
  className?: string;
}

/**
 * Live countdown with urgency states (danger overdue ?? warning <1h ?? info <6h).
 * Re-renders every 15s so the label stays truthful while the phone is in use.
 */
export function DeadlineTag({ job, showSub = false, className }: DeadlineTagProps) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 15_000);
    return () => window.clearInterval(id);
  }, []);

  const info: DeadlineInfo = deadlineInfo(job, now);

  return (
    <span
      className={['deadline', `deadline--${info.tone}`, className].filter(Boolean).join(' ')}
      data-testid="deadline"
      data-tone={info.tone}
      title={info.sub}
    >
      <span className="deadline__dot" aria-hidden="true" />
      <span className="deadline__label">{info.label}</span>
      {showSub && info.sub !== '—' ? <span className="deadline__sub u-data">{info.sub}</span> : null}
    </span>
  );
}
